
const ID = ':id';

export const COMPLIANCE_P = 'compliance';
export const COMPLIANCE_PF = `/${COMPLIANCE_P}`;

export const FLOWS_P       = 'flows';
export const FLOWS_PF      = `${COMPLIANCE_PF}/${FLOWS_P}`;
export const FLOW_P = 'flow';
export const FLOW_PF = `${COMPLIANCE_PF}/${FLOW_P}`;
export const FLOW_STEP1_P = 'step1';
export const FLOW_STEP1_PF = `${FLOW_PF}/${FLOW_STEP1_P}`;
export const FLOW_STEP2_P = 'step2';
export const FLOW_STEP2_PF = `${FLOW_PF}/${FLOW_STEP2_P}`;
export const FLOW_STEP3_P = 'step3';
export const FLOW_STEP3_PF = `${FLOW_PF}/${FLOW_STEP3_P}`;
export const FLOW_STEP4_P = 'step4';
export const FLOW_STEP4_PF = `${FLOW_PF}/${FLOW_STEP4_P}`;

export const FLOWS_VALIDATE_P = `${FLOWS_P}-validate`;
export const FLOWS_VALIDATE_PF = `${COMPLIANCE_PF}/${FLOWS_VALIDATE_P}`;
export const FLOWS_VALIDATE_STEP1_P = 'step1';
export const FLOWS_VALIDATE_STEP1_PF = `${FLOWS_VALIDATE_PF}/${FLOW_STEP1_P}`;
export const FLOWS_VALIDATE_STEP2_P = 'step2';
export const FLOWS_VALIDATE_STEP2_PF = `${FLOWS_VALIDATE_PF}/${FLOW_STEP2_P}`;
export const FLOWS_VALIDATE_STEP3_P = 'step3';
export const FLOWS_VALIDATE_STEP3_PF = `${FLOWS_VALIDATE_PF}/${FLOW_STEP3_P}`;

export const DOCUMENTS_P = 'documents';
export const DOCUMENT_PF = `${COMPLIANCE_PF}/${DOCUMENTS_P}`;
export const DOCUMENT_ID_P = `document-detail/${ID}`;
export const DOCUMENT_ID_PF = `${COMPLIANCE_PF}/${DOCUMENT_ID_P}`;

export const TEMPLATES_P = 'templates';
export const TEMPLATES_PF = `${COMPLIANCE_PF}/${TEMPLATES_P}`;
export const TEMPLATE_ID_P = `template-detail/${ID}`;
export const TEMPLATE_ID_PF = `${COMPLIANCE_PF}/${TEMPLATE_ID_P}`;

export const VERIFY_DOCUMENT_P = 'verify-document';
export const VERIFY_DOCUMENT_PF = `${COMPLIANCE_PF}/${VERIFY_DOCUMENT_P}`;

export const FLEET_P = 'fleet';
export const FLEET_PF = `${COMPLIANCE_PF}/${FLEET_P}`;
export const FLEET_ID_P = `fleet-detail/${ID}`;
export const FLEET_ID_PF = `${COMPLIANCE_PF}/${FLEET_ID_P}`;